import { type Bounds, bounds } from '@ipfabric/utils';
import type { Eq } from 'fp-ts/lib/Eq';
import { Rectangle } from 'pixi.js';

export const boundsEq: Eq<Bounds> = {
  equals: bounds.equals,
};

export const boundsToPIXIRectangle = (b: Bounds): Rectangle =>
  new Rectangle(b.left, b.top, b.right - b.left, b.bottom - b.top);
